import React from "react"
import Loading from "../../../Loading";

const Processing = () => (
  <div>
    <div className="loading-container">
      <Loading />
    </div>
    <p className="loading-message">This file is processing. Please wait...</p>
    <p className="loading-message">
      Do not close, refresh or navigate away from this page
    </p>
  </div>
);

export default Processing;



// WEBPACK FOOTER //
// ./src/components/runsheets/list/upload/Processing.js